// extracted by mini-css-extract-plugin
export default {"Container":"PageContainer_Container__scI-T"};